var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas fa-male text-xl",class:{ selected: _vm.isGender(0) },on:{"click":function($event){return _vm.setGender(0)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-female text-xl",class:{ selected: _vm.isGender(1) },on:{"click":function($event){return _vm.setGender(1)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }